import ParentCellOrFragment from '@app/src/components/Table/Cells/ParentCellOrFragment'
import { ErrorOutline } from '@mui/icons-material'
import { Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

const ScrapingFailedCell: React.FC = () => {
  const { formatMessage } = useIntl()
  return (
    <ParentCellOrFragment>
      <Stack direction="row" alignItems="center" spacing={1}>
        <ErrorOutline sx={({ palette }) => ({ color: palette.semantic.error })} />
        <Typography variant="body2" color="text.secondary">
          {formatMessage({
            id: 'resourceCollections.general.screeningFailed',
          })}
        </Typography>
      </Stack>
    </ParentCellOrFragment>
  )
}

export default ScrapingFailedCell
